import clarity from '@microsoft/clarity';

let clarityInitialized = false;

export function initClarity() {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  if (!projectId) {
    console.warn('[Clarity] Missing REACT_APP_CLARITY_PROJECT_ID.');
    return;
  }

  if (clarityInitialized || window.__clarity_initialized) {
    return;
  }

  try {
    clarity.init(projectId);

    window.__clarity_initialized = true;
    clarityInitialized = true;
  } catch (err) {
    console.error('[Clarity] Initialization failed', err);
  }
}